/* stylelint-disable */

interface Registration {
  email: string;
  timestamp: number;
  name: string;
  company: string;
}

interface RegistrationsData {
  registrations: Registration[];
  totalSpots: number;
  lastUpdated: string | null;
  version: string;
}

export async function saveRegistration(email: string, name: string, company: string): Promise<boolean> {
  console.log("Simulated saveRegistration:", { email, name, company });
  return true;
}

export async function getRegistrationStatus(): Promise<{
  totalSpots: number;
  spotsLeft: string;
  lastUpdated: string | null;
}> {
  return {
    totalSpots: 100,
    spotsLeft: "Few Spots left",
    lastUpdated: new Date().toISOString(),
  };
}

export async function getAllRegistrations(): Promise<Registration[]> {
  return [];
} 